import { INewbuildingBuilder } from '../../types/newbuilding/builder';
import {
  getAnalyticsRegionId,
  getGaLabel,
  getProductsData,
  getPageData,
  getNewbuildingExtra,
} from '../../selectors/analytics';
import { TThunkAction } from '../../types/redux';
import { trackCall } from '../../analytics/promos/trackCall';

export function handleCall(builder: INewbuildingBuilder): TThunkAction {
  return (dispatch, getState) => {
    const state = getState();
    const extra = getNewbuildingExtra(state);

    const analyticParams = {
      label: getGaLabel(state),
      products: [getProductsData(state.newbuilding.id, builder, extra)],
      page: {
        ...getPageData(builder),
        customPageURL: getGaLabel(state),
        region: getAnalyticsRegionId(state),
        extra,
      },
      modelVersion: '1',
    };
    const timerId = window.setTimeout(trackCall, 10000, analyticParams);
    /* istanbul ignore next */
    const onFocusListener = () => {
      clearTimeout(timerId);
    };

    window.addEventListener('focus', onFocusListener);
  };
}
